import React from 'react';
import SignalsTab from './SignalsTab';
import FlowAlertsTab from './FlowAlertsTab';
import VolatilityTab from './VolatilityTab';
import GammaTab from './GammaTab';
import FlowPerStrikeTab from './FlowPerStrikeTab';
import { 
  StockDataPoint, 
  VolatilityResponse, 
  GammaExposurePoint, 
  GammaMetricKey, 
  FlowPerStrikePoint, 
  FlowMetricKey 
} from '../types/StockData';

type TabType = 'signals' | 'flow' | 'volatility' | 'gamma' | 'flowPerStrike';

interface TabContentProps {
  activeTab: TabType;
  selectedDataPoint: StockDataPoint | null;
  data: StockDataPoint[];
  
  // Volatility props
  volatilityData: VolatilityResponse | null;
  volatilityLoading: boolean;
  
  // Gamma props
  gammaData: GammaExposurePoint[];
  gammaLoading: boolean;
  selectedGammaMetric: GammaMetricKey;
  onGammaMetricChange: (metric: GammaMetricKey) => void;
  
  // Flow Per Strike props
  flowPerStrikeData: FlowPerStrikePoint[];
  flowPerStrikeLoading: boolean;
  selectedFlowMetric: FlowMetricKey;
  onFlowMetricChange: (metric: FlowMetricKey) => void;
}

const TabContent: React.FC<TabContentProps> = ({
  activeTab,
  selectedDataPoint,
  data,
  volatilityData,
  volatilityLoading,
  gammaData,
  gammaLoading,
  selectedGammaMetric,
  onGammaMetricChange,
  flowPerStrikeData,
  flowPerStrikeLoading,
  selectedFlowMetric,
  onFlowMetricChange
}) => {
  switch (activeTab) {
    case 'signals':
      return <SignalsTab selectedDataPoint={selectedDataPoint} />;
    
    case 'flow':
      return <FlowAlertsTab selectedDataPoint={selectedDataPoint} />;
    
    case 'volatility':
      return (
        <VolatilityTab 
          volatilityData={volatilityData} 
          volatilityLoading={volatilityLoading} 
        />
      );
    
    case 'gamma':
      return (
        <GammaTab
          gammaData={gammaData}
          gammaLoading={gammaLoading}
          selectedGammaMetric={selectedGammaMetric}
          onGammaMetricChange={onGammaMetricChange}
          selectedDataPoint={selectedDataPoint}
          data={data}
        />
      );
    
    case 'flowPerStrike':
      return (
        <FlowPerStrikeTab
          flowPerStrikeData={flowPerStrikeData}
          flowPerStrikeLoading={flowPerStrikeLoading}
          selectedFlowMetric={selectedFlowMetric}
          onFlowMetricChange={onFlowMetricChange}
          selectedDataPoint={selectedDataPoint}
          data={data}
        />
      );
    
    default:
      return null;
  }
};

export default TabContent;
